import React, { useEffect, useState } from 'react';
import { Col, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { debounceTodayAbsencesReport } from '../../../requests/todayAbsences';
import Icon from '../../Icons';
import HRDashboardStyled from '../../HRDashboardStyled';

const TeamAbsencesToday = ({
  employeesBelongBoss,
  successFetchEmployee,
  handleMoreInfoButton,
  showSpinnerToday,
  setShowSpinnerToday
}) => {
  const dispatch = useDispatch();
  const today = moment().format('YYYY-MM-DD');
  const [graphData, setGraphData] = useState({
    licenses: 0,
    unjustified: 0,
    vacations: 0,
    administrative: 0,
    permissions: 0,
    assistants: 0,
    totals: 0
  });

  const handleAttendanceReportRequest = (format = '.print') => {
    debounceTodayAbsencesReport({
      dispatch,
      params: {
        filter_by_employee: employeesBelongBoss,
        date_range: [today, today]
      },
      format,
      successCallback: response => {
        const { data } = response;
        setGraphData({
          licenses: data.filter(asItem => ['Licencia Medica', 'Prenatal'].includes(asItem.records[0]?.justification))
            .length,
          unjustified: data.filter(asItem => asItem.records[0]?.justification === 'Ausencia Injustificada').length,
          vacations: data.filter(asItem => asItem.records[0]?.justification === 'Vacaciones').length,
          administrative: data.filter(asItem => asItem.records[0]?.justification === 'Administrativos').length,
          permissions:
            data.filter(asItem => asItem.records[0]?.justification === 'Permiso con goce de Remuneraciones').length +
            data.filter(asItem => asItem.records[0]?.justification === 'Permiso sin goce de Remuneraciones').length,
          assistants: data.filter(asItem => asItem.records[0]?.attendance === 'Si').length,
          totals: data.filter(asItem => asItem.records[0]?.attendance === 'No').length
        });
      },
      callback: () => setShowSpinnerToday(false)
    });
  };

  const handleAttendanceEffect = () => {
    if (successFetchEmployee) {
      if (employeesBelongBoss && employeesBelongBoss.length > 0) {
        handleAttendanceReportRequest();
      } else {
        setShowSpinnerToday(false);
      }
    }
  };
  useEffect(handleAttendanceEffect, [employeesBelongBoss, successFetchEmployee]);

  return (
    <>
      {showSpinnerToday === true ? (
        <Col className="mt-5">
          <div className="containerSpinnerLoadDash mb-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Col>
      ) : (
        <>
          <HRDashboardStyled
            title={graphData}
            label="Asistencias/Ausencias de Hoy"
            labelColor="#827f7f"
            TopHeaderColor="#fff"
            GeneralColor="#21653b"
            subtitle="Solicitudes pendientes por Aprobar/Firmar"
            TypeCard="TodayAttendanceAbsences"
            onRequest={false}
            Downloadable={false}
            labelFontSize="12px"
          />
          <button
            type="button"
            onClick={handleMoreInfoButton}
            style={{
              border: '1px solid #65b68f',
              backgroundColor: '#65b68f',
              position: 'absolute',
              right: 20,
              bottom: 10
            }}
          >
            <Icon icon="search" height="25px" width="16px" color="white" />
          </button>
        </>
      )}
    </>
  );
};

export default TeamAbsencesToday;
